module.exports = __webpack_public_path__ + "img/bg-img-news-and-announcements3.41372e13.png";